import { useEffect } from "react";
import { useDragLayer } from "react-dnd";
import { DND_ITEM_TYPES } from "./supplyTableRow";

const SCROLL_ZONE_HEIGHT = 80; // px from top/bottom edge to trigger scroll
const MAX_SCROLL_SPEED = 12;   // px per frame at the edge

/**
 * Invisible component: auto-scrolls window while dragging a PRODUCT_ROW item.
 * Place this inside DndProvider.
 */
const DragAutoScroll = () => {
  const { isDragging, clientOffset } = useDragLayer((monitor) => ({
    isDragging: [DND_ITEM_TYPES.PRODUCT_ROW, DND_ITEM_TYPES.HIDDEN_ROW, DND_ITEM_TYPES.ADD_PRODUCT_ROW].includes(monitor.getItemType()),
    clientOffset: monitor.getClientOffset(),
  }));

  useEffect(() => {
    if (!isDragging || !clientOffset) return;

    let rafId = null;

    const scroll = () => {
      const { y } = clientOffset;
      const viewportHeight = window.innerHeight;

      if (y < SCROLL_ZONE_HEIGHT) {
        // Near top → scroll up
        const ratio = 1 - y / SCROLL_ZONE_HEIGHT;
        const speed = Math.round(ratio * MAX_SCROLL_SPEED);
        window.scrollBy(0, -speed);
      } else if (y > viewportHeight - SCROLL_ZONE_HEIGHT) {
        // Near bottom → scroll down
        const ratio = (y - (viewportHeight - SCROLL_ZONE_HEIGHT)) / SCROLL_ZONE_HEIGHT;
        const speed = Math.round(ratio * MAX_SCROLL_SPEED);
        window.scrollBy(0, speed);
      }

      rafId = requestAnimationFrame(scroll);
    };

    rafId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(rafId);
  }, [isDragging, clientOffset]);

  return null;
};

export default DragAutoScroll;
